import {MenuItem} from './menu.model';

export const COLLABORATORS_MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    isTitle: true
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARDS.TEXT',
    icon: 'ri-dashboard-line',
    link: '/driving-school'
  },
  {
    id: 3,
    label: 'My Earnings',
    icon: 'fas fa-rupee-sign',
    link: '/driving-school/my-earnings'
  },
];
